import { Map } from 'immutable';

/**
 * Takes a flat array of field keys and groups them into pairs for two-column
 * table layouts. If the array has an odd length, the last pair has null as
 * its second element so the caller can render an empty cell.
 */
export function pairUp<T> (fields: T[]): [T, T | null][] {
  const pairs: [T, T | null][] = [];
  for (let i = 0; i < fields.length; i += 2) {
    pairs.push([fields[i], fields[i + 1] ?? null]);
  }
  return pairs;
}

/**
 * Resolves the deviceId a commissioning report should persist. Prefers the value held in
 * local form state so an in-modal link/unlink/relink is honoured — including an intentional
 * unlink (deviceId === null). Only falls back to the prop deviceId when state has no value.
 *
 * Uses hasIn, NOT ??: an explicit null in state is a deliberate unlink and must survive, so
 * it cannot be collapsed back to the prop deviceId the way `?? deviceId` would.
 */
export function resolveEffectiveDeviceId (allResults: Map<string, any>, deviceId?: string | null): string | null {
  return allResults.hasIn(['info', 'deviceId'])
    ? (allResults.getIn(['info', 'deviceId']) as string | null)
    : (deviceId || null);
}
